import { reactive } from "vue";
import store from "../../../../../store";
import { createLoading } from "../../../../../utils/loading";
import { createManageExportCsv, createPage } from "../../../../../utils/page";
import { createColumns } from "./hc.section";
import lodash from "lodash";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/certificateRequest";
export const routerPrefix = "company-report-hc";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const onSearch = ({ page, isSet = true }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({
        criteria: {
            ...page,
            data: [],
            where: [
                ...where,
                { name: "isActive", type: "Boolean", operator: "=", value: true },
                { name: "refRequestStatus.key", type: "String", operator: "in", value: ["Cancel", "Wait Print", "Printed"] }
            ],
            sort: [...sort]
        }
    })
        .then(page => (isSet ? (state.page = { ...page, where, sort }) : page))
        .finally(() => setIsLoading(false));
};

export const initState = ({ props }) => {
    const menuContext = props.menuContext;
    state.columns = createColumns({ props }).map(d => {
        return lodash.mergeWith(
            state.columns.find(d2 => d.dataIndex === d2.dataIndex),
            d,
            (objValue, srcValue, key) => {
                if (["searchValue"].includes(key)) return objValue;
            }
        );
    });
    state.manages = [createManageExportCsv({ menuContext, callData: ({ page }) => onSearch({ props, page: { ...lodash.cloneDeep({ ...page, page: 0, size: 1000000 }) }, isSet: false }) })];
    state.manageExtras = [];
    state.rowActions = [];
};

export const state = reactive({
    columns: [],
    page: createPage({
        options: {
            select: ["*", "refCompany.*", "refCompany.refDepartment.*", "refExportCountry.*", "refTransportMode.*", "refRequestStatus.*"],
            sort: [{ name: "updateDate", type: "DESC" }],
            children: [
                {
                    name: "aquaticScientificNames",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                },
                {
                    name: "certificateProducts",
                    select: ["*", "refSamplingProduct.refExportAmountUnit.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                }
            ]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } }
});
